import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { MarketingSite } from "./MarketingSite";
import "./marketing.css";

async function retireLegacyCorePwa(): Promise<void> {
  const canonicalApex = "https://billybank.fr";
  const rootScope = new URL("/", window.location.origin).href;
  const legacyWorkerUrl = new URL("/sw.js", window.location.origin).href;

  if (window.location.origin === canonicalApex && "serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations
      .filter((registration) => (
        registration.scope === rootScope
        && registration.active?.scriptURL === legacyWorkerUrl
      ))
      .map((registration) => registration.unregister()));
  }
  if (window.location.origin === canonicalApex && "caches" in globalThis) {
    const keys = await caches.keys();
    await Promise.all(keys
      .filter((key) => key.startsWith("billy-beta-"))
      .map((key) => caches.delete(key)));
  }
}

const root = document.getElementById("root");

if (!root) throw new Error("marketing_root_missing");

window.addEventListener("load", () => {
  void retireLegacyCorePwa().catch(() => undefined);
}, { once: true });

createRoot(root).render(
  <StrictMode>
    <MarketingSite />
  </StrictMode>,
);
